import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3a0c695a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "cursor-pointer w-full h-full flex flex-col drawer-button items-center justify-center opacity-60 hover:opacity-100"
};
const _hoisted_2 = {
  class: "w-[32px] h-[32px]"
};
const _hoisted_3 = {
  class: "text-[10px]"
};
import { useConfiguratorStore } from "@/stores/configurator";
// import { Icon } from '@iconify/vue';

export default {
  __name: 'SidebarButton',
  props: {
    name: String,
    icon: String,
    isActive: {
      type: Boolean,
      default: false
    },
    openDrawer: {
      type: Boolean,
      require: false,
      default: true
    }
  },
  setup(__props) {
    const configuratorStore = useConfiguratorStore();
    const {
      showDrawer
    } = configuratorStore;
    return (_ctx, _cache) => {
      const _component_SvgIcon = _resolveComponent("SvgIcon");
      return _openBlock(), _createElementBlock("button", {
        class: _normalizeClass(["sb-button btn btn-square btn-lg btn-ghost capitalize hover:bg-backgroundDrawer focus:bg-backgroundDrawer focus:outline-none", {
          'bg-backgroundDrawer': __props.isActive
        }]),
        onClick: _cache[0] || (_cache[0] = $event => _unref(showDrawer)(__props.openDrawer))
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("span", _hoisted_2, [_createVNode(_component_SvgIcon, {
        class: "w-full h-full",
        fill: "white",
        svgSymbolId: __props.icon
      }, null, 8, ["svgSymbolId"])]), _createElementVNode("span", _hoisted_3, _toDisplayString(__props.name), 1)])], 2);
    };
  }
};